<template>
  <div style="min-width: 100%; min-height: 6rem">
    <div @click="show" style="min-width: 100%; height: 100%">
      <div v-if="item.Qty == 0">
        <van-icon name="user-o" />
        <div class="C1">{{ item.ItemName }}</div>
      </div>
      <div v-else>
        <!-- <van-icon name="user-o" /> -->
        <!-- <div class="C1">{{ item.ItemName }}</div> -->
        <div class="text-size">
          {{ item.ItemName }}
          <span v-if="item.Qty != 1">x{{ item.Qty }}</span>
        </div>
        <!-- {{ Object.keys(item) }}
        {{ item }} -->
        <!-- <div>x{{ item.Qty }}</div>
      <span v-if="item.Qty > 1">x{{ item.Qty }}</span> -->
      </div>
      <van-tag size="large" v-if="getS2(item) != ''">
        {{ getS2(item).join(" / ") }}
      </van-tag>
      <!-- <van-icon name="contact-o" />
      <van-icon name="user-o" /> -->
      <!-- <van-button
        v-bind:class="item.Qty == 0 ? 'uncheck' : 'checked'"
        style="height: 5rem"
        >{{ item.ItemName }}
        <span v-if="item.Qty > 1">x{{ item.Qty }}</span>

        <van-tag size="large" v-if="getS2(item) != ''">
          {{ getS2(item).join(" / ") }}
        </van-tag>
      </van-button> -->
    </div>
    <!-- {{ $store.state.config }} -->
    <!-- {{ $store.getters.getConfig("color4") }} -->

    <van-popup v-model="visible" position="bottom">
      <!-- <van-nav-bar :title="title" left-arrow @click-left="visible = false" /> -->
      <van-sticky>
        <van-nav-bar :title="title" left-arrow @click-left="close" />
      </van-sticky>
      <div class="main" v-if="bkmenu">
        <MenuTB :bkmenu="bkmenu" @click="showItem" />
      </div>

      <van-tabbar fixed placeholder>
        <van-button @click="close"> 返回 </van-button>
      </van-tabbar>
    </van-popup>

    <!-- 彈出層視窗 -->
    <FrmItemDetail ref="rFrmItemDetail" @callback="refresh" @add="addItem" />
  </div>
</template>

<style scoped>
.van-tag {
  margin: 0.3rem;
}
.van-icon {
  font-size: 2rem;
  margin: 0.4rem;
}

.uncheck {
  color: #5237eb;
  background-color: white;
}
.checked {
  color: white;
  background-color: #0c9630;
}
.van-popup {
  height: 100%;
}
</style>

<script>
// import ItemDetail from "./ItemDetail.vue";
import MenuTB from "./MenuTB/MenuTB.vue";
import FrmItemDetail from "./FrmItemDetail.vue";

export default {
  components: { MenuTB, FrmItemDetail },
  props: {
    title: String,
    // exttype: Object,
    // bkmenu: Object,
    item: Object,
  },
  data() {
    return {
      visible: false,
      obj: {},
      custtotal: 0,
      loading: false,
      items: [],

      bkmenu: null,
    };
  },
  async mounted() {
    // console.log("BKMenu.monted");
    // await this.init();
    // this.gLoading();
    // await this.refresh();
    // this.gClear();
    // setInterval(() => {
    //   this.refresh();
    // }, 60 * 1000);
  },
  methods: {
    getExtType(pId) {
      let data = this.$store.state.exttype.filter((r) => r.posOnly);
      return data.find(data.find((r) => r.id == pId));
    },
    show() {
      this.bkmenu = this.$store.state.bkmenu;
      this.visible = true;
    },

    close() {
      //   this.obj = {};
      this.bkmenu = null;
      this.visible = false;
    },

    showItem(obj) {
      console.log(obj);
      this.$refs.rFrmItemDetail.show(obj);
    },
    getS2(pItem) {
      let array = [];
      let groups = pItem.Groups;
      // console.log("groups", groups);
      if (!groups) return array;
      groups.forEach((g) => {
        let options = g.options;
        array = array.concat(options);
      });

      array = array.filter((r) => r.Qty > 0);
      array = array.filter((r) => r.ItemName.toString().trim() != "");
      array = array.map((r) => {
        if (r.Qty > 1) return r.ItemName + "x" + r.Qty;
        return r.ItemName;
      });
      return array;
    },

    async refresh() {
      console.log("refresh");
      //   var res = await this.apiGetOrdertmp();
      //   this.$store.commit("setOrderTmp", res.data);
      //   this.gClearLoading();
    },
    addItem(pObj) {
      // console.log("addItem", JSON.stringify(pObj));
      this.$emit("add", pObj);
      this.visible = false;
      //   var res = await this.apiGetOrdertmp();
      //   this.$store.commit("setOrderTmp", res.data);
      //   this.gClearLoading();
    },

    async init() {
      try {
        // var res = await this.apiGetBKMenu();
        // this.bkmenu = res.data;
        // // console.log("bkmenu", this.bkmenu);
        // let extitem = this.bkmenu.extitem;
        // if (extitem[0]) this.items.push(extitem[0]);
        // if (extitem[1]) this.items.push(extitem[1]);
      } catch (error) {
        console.log(error.toString());
      }
    },
  },
};
</script>
